export default "__VITE_ASSET__eb95cb2d__"